import React, { useEffect } from "react";
import RightsScreen from "./store/containers/RightsScreenContainer";
import SideBar from "./store/containers/SideBarContainer";
import LoginScreen from "./store/containers/LoginScreenContainer";
import PrivacyPolicyScreen from "./screens/PrivacyPolicyScreen";
import AddEditRightScreen from "./store/containers/AddEditRightScreenContainer";
import AddEditSubrightScreen from "./store/containers/AddEditSubrightScreenContainer";
import AddEditLearnMoreScreen from "./store/containers/AddEditLearnMoreScreenContainer";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

export default function App({
  isAuthenticated,
  fetchTranslationMap,
  fetchOrgs,
}) {
  useEffect(() => {
    fetchTranslationMap();
    fetchOrgs();
  });

  return (
    <BrowserRouter>
      {isAuthenticated ? <SideBar /> : null}
      <Routes>
        <Route
          path="/"
          exact
          element={
            !isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : (
              <Navigate to="/rights" replace />
            )
          }
        />

        <Route
          path="/rights"
          exact
          element={
            !isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : (
              <RightsScreen />
            )
          }
        />

        <Route
          path="/rights/info"
          exact
          element={
            !isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : (
              <AddEditRightScreen />
            )
          }
        />
        <Route
          path="/rights/subright"
          exact
          element={
            !isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : (
              <AddEditSubrightScreen />
            )
          }
        />

        <Route
          path="/rights/learnMore"
          exact
          element={
            !isAuthenticated ? (
              <Navigate to="/login" replace />
            ) : (
              <AddEditLearnMoreScreen />
            )
          }
        />

        <Route
          path="/login"
          exact
          element={
            isAuthenticated ? <Navigate to="/" replace /> : <LoginScreen />
          }
        />

        <Route path="/privacy-policy" exact element={<PrivacyPolicyScreen />} />
      </Routes>
    </BrowserRouter>
  );
}
